import React, { useState } from 'react';
import {
  Box,
  Button,
  TextField,
  Select,
  MenuItem,
  Typography,
  IconButton,
  Modal,
  FormControl,
  InputLabel
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from "@mui/icons-material/Close";
import { tokens } from "../../theme";
import SearchableDataGrid from '../../components/SearchableDataGrid';

const Collection1 = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const colors = tokens(theme.palette.mode);

  const [rows, setRows] = useState([
    {
      id: 1,
      collectionRequestNo: '',
      customerId: '',
      partyId: '',
      siteName: '',
      date: '',
      invoiceno: '',
      invoiceAmount: '',
      invoiceDate: '',
      installmentNumber: '',
      status: '',
      delinquentReason: '',
      collectorId: '',
      flag: '',
    }
  ]);

  const [openModal, setOpenModal] = useState(false);

  const handleAddRow = () => {
    setRows([
      ...rows,
      {
        id: rows.length + 1,
        collectionRequestNo: '',
        customerId: '',
        partyId: '',
        siteName: '',
        date: '',
        invoiceno: '',
        invoiceAmount: '',
        invoiceDate: '',
        installmentNumber: '',
        status: '',
        delinquentReason: '',
        collectorId: '',
        flag: '',
      }
    ]);
  };

  const handleRowChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };

  const handleDeleteRow = (id) => {
    const updatedRows = rows.filter(row => row.id !== id);
    setRows(updatedRows);
  };

  const handleSave = () => {
    setOpenModal(false);
  };

  const columns = [
    { field: 'id', headerName: 'Sl.No', flex: 0.3 },
    {
      field: 'collectionRequestNo',
      headerName: 'Collection Request Number',
      flex: 1,
      renderCell: (params) => (
        <TextField
          value={params.row.collectionRequestNo}
          onChange={(e) => handleRowChange(params.row.id - 1, 'collectionRequestNo', e.target.value)}
          fullWidth
        />
      )
    },
    {
      field: 'customerId',
      headerName: 'Customer Id',
      flex: 1,
      renderCell: (params) => (
        <TextField
          value={params.row.customerId}
          onChange={(e) => handleRowChange(params.row.id - 1, 'customerId', e.target.value)}
          fullWidth
        />
      )
    },
    {
      field: 'partyId',
      headerName: 'Party Id',
      flex: 1,
      renderCell: (params) => (
        <TextField
          value={params.row.partyId}
          onChange={(e) => handleRowChange(params.row.id - 1, 'partyId', e.target.value)}
          fullWidth
        />
      )
    },
    {
      field: 'siteName',
      headerName: 'Customer Level2 Info',
      flex: 1,
      renderCell: (params) => (
        <TextField
          value={params.row.siteName}
          onChange={(e) => handleRowChange(params.row.id - 1, 'siteName', e.target.value)}
          fullWidth
        />
      )
    },
    {
      field: 'date',
      headerName: 'Date',
      flex: 1,
      renderCell: (params) => (
        <TextField
          type="date"
          value={params.row.date}
          onChange={(e) => handleRowChange(params.row.id - 1, 'date', e.target.value)}
          fullWidth
        />
      )
    },
    {
      field: 'invoiceno',
      headerName: 'Invoice No',
      flex: 1,
      renderCell: (params) => (
        <TextField
          value={params.row.invoiceno}
          onChange={(e) => handleRowChange(params.row.id - 1, 'invoiceno', e.target.value)}
          fullWidth
        />
      )
    },
    {
      field: 'invoiceAmount',
      headerName: 'Invoice Amount',
      flex: 1,
      renderCell: (params) => (
        <TextField
          type="number"
          value={params.row.invoiceAmount}
          onChange={(e) => handleRowChange(params.row.id - 1, 'invoiceAmount', e.target.value)}
          fullWidth
        />
      )
    },
    {
      field: 'invoiceDate',
      headerName: 'Invoice Date',
      flex: 1,
      renderCell: (params) => (
        <TextField
          type="date"
          value={params.row.invoiceDate}
          onChange={(e) => handleRowChange(params.row.id - 1, 'invoiceDate', e.target.value)}
          fullWidth
        />
      )
    },
    {
      field: 'installmentNumber',
      headerName: 'Installment Number',
      flex: 1,
      renderCell: (params) => (
        <TextField
          type="number"
          value={params.row.installmentNumber}
          onChange={(e) => handleRowChange(params.row.id - 1, 'installmentNumber', e.target.value)}
          fullWidth
        />
      )
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      renderCell: (params) => (
        <Select
          value={params.row.status}
          onChange={(e) => handleRowChange(params.row.id - 1, 'status', e.target.value)}
          fullWidth
        >
          <MenuItem value="Paid">Paid</MenuItem>
          <MenuItem value="Overdue">Overdue</MenuItem>
          <MenuItem value="Pending">Pending</MenuItem>
          <MenuItem value="Delinquent">Delinquent</MenuItem>
          <MenuItem value="Criticality">Criticality</MenuItem>
          <MenuItem value="Due">Due</MenuItem>
          <MenuItem value="Resolved">Resolved</MenuItem>
        </Select>
      )
    },
    {
      field: 'delinquentReason',
      headerName: 'Delinquent Reason',
      flex: 1,
      renderCell: (params) => (
        <TextField
          value={params.row.delinquentReason}
          onChange={(e) => handleRowChange(params.row.id - 1, 'delinquentReason', e.target.value)}
          fullWidth
        />
      )
    },
    {
      field: 'collectorId',
      headerName: 'Collector Id',
      flex: 1,
      renderCell: (params) => (
        <TextField
          value={params.row.collectorId}
          onChange={(e) => handleRowChange(params.row.id - 1, 'collectorId', e.target.value)}
          fullWidth
        />
      )
    },
    {
      field: 'flag',
      headerName: 'Flag',
      flex: 1,
      renderCell: (params) => (
        <Select
          value={params.row.flag}
          onChange={(e) => handleRowChange(params.row.id - 1, 'flag', e.target.value)}
          fullWidth
        >
          <MenuItem value="Active">Active</MenuItem>
          <MenuItem value="Freeze">Freeze</MenuItem>
        </Select>
      )
    },
    {
      field: 'action',
      headerName: 'Action',
      flex: 0.5,
      cellClassName: 'sticky-action-column',
      headerClassName: 'sticky-action-column',
      renderCell: (params) => (
        <IconButton
          color="secondary"
          onClick={() => handleDeleteRow(params.row.id)}
        >
          <DeleteIcon />
        </IconButton>
      ),
    }
  ];

  return (
    <Box m="20px">
      <h2>Collection Schedules</h2>

      <Box display="flex" justifyContent="space-between" mb="20px">
        <Button
          variant="contained"
          onClick={handleAddRow}
          sx={{
            backgroundColor: colors.blueAccent[700],
            color: colors.primary[400],
            fontSize: "14px",
            fontWeight: "bold",
            margin: "10px",
          }}
        >
          + Add Row
        </Button>
        <Button
          variant="contained"
          onClick={handleSave}
          sx={{
            backgroundColor: colors.blueAccent[700],
            color: colors.primary[400],
            fontSize: "14px",
            fontWeight: "bold",
            margin: "10px",
          }}
        >
          Save
        </Button>
      </Box>

      <Box
  sx={{
    width: '100%',
    overflowX: 'auto', // Enables horizontal scroll
  }}
>
  <Box
    sx={{
      minWidth: '1600px', // Wider than viewport to force horizontal scroll
      height: '50vh',
      "& .MuiDataGrid-root": {
        border: "none",
      },
      "& .MuiDataGrid-cell": {
        borderBottom: "1px solid grey",
        whiteSpace: "nowrap",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: colors.blueAccent[700],
        borderBottom: "none",
        fontSize: "14px",
      },
      "& .MuiDataGrid-virtualScroller": {
        backgroundColor: colors.primary[400],
      },
      "& .MuiDataGrid-footerContainer": {
        borderTop: "none",
        backgroundColor: colors.blueAccent[900],
        height: "5vh",
      },
      "& .MuiCheckbox-root": {
        color: `${colors.greenAccent[200]} !important`,
      },
      "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
        color: `${colors.grey[100]} !important`,
      },
      "& .sticky-action-column": {
        position: 'sticky',
        right: 0,
        backgroundColor: colors.primary[400],
        zIndex: 2,
      },
    }}
  >
    <SearchableDataGrid
      rows={rows}
      columns={columns}
      pageSize={5}
      autoHeight
      checkboxSelection
      disableSelectionOnClick
    />
  </Box>
</Box>

      {/* Optional Modal */}
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <IconButton
            sx={{ position: "absolute", top: 8, right: 8 }}
            onClick={() => setOpenModal(false)}
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6">Modal Title</Typography>
        </Box>
      </Modal>
    </Box>
  );
};

export default Collection1;